import React from "react";
import SelectInput from './SelectInput';
import TextInput from './TextInput';
import addRataStatus from "../services/addRataStatus";
import saveFile from "../services/saveFile";
import Cookies from 'universal-cookie';
import uuid from 'react-uuid';
import Constants from "../utils/consts";
import Button from './Button';
import fileImage from '../images/file.png'
import MyDatePicker from "./DatePickerIta";
import moment from 'moment';

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import './css/editor.css';
import ImageSilentInput from "./ImageSilentInput";
import translateString from "../utils/Locales";

let tr = translateString;

export default class RataDaVerificareWidget extends React.Component {

    constructor(props){
        super(props);

        this.rataDateRef = React.createRef();
        this.importoRef = React.createRef();
        this.importo = 0;

        this.options = [];
        this.options.push({ value: 'NON PAGATA', label: tr('non_pagata_s')});
        this.options.push({ value: 'DA VERIFICARE', label: tr('DA VERIFICARE')});
        this.options.push({ value: 'PAGATA', label: tr('PAGATA')});
        this.files = [];
        this.newFiles = [];
        this.deletedFiles = [];
        this.newNote = undefined;

        this.state = {
            option: this.option,
        }
    }

    onContentStateChange = contentState => {

        this.savedEnabled = true;
        this.setState({ contentState});
       }

    componentDidMount(){
        this.option = this.options.find(o => o.value == this.props.status);
        this.setState({
            option: this.option,
        });
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(prevProps.rata) != JSON.stringify(this.props.rata)) {
            this.option = this.options.find(o => o.value == this.props.status);
            this.importo = this.props.rata.importo;
            this.data = this.props.rata.data;
            this.setState({option: this.option,
                note: this.props.rata.note,
            });
        }
        this.newFiles = [];
        this.deletedFiles = [];
        this.newNote = undefined;
    }

    render (){

        if (this.props.rata == undefined) return null;

        this.files = [];
        var tempArr = this.props.rata.files ? this.props.rata.files.split(';') : [];
        for (var t of tempArr)
            if (t != '' && this.deletedFiles.indexOf(t) == -1) 
                this.files.push(t);
        for (var t of this.newFiles)
            if (t != '' && this.deletedFiles.indexOf(t) == -1) 
                this.files.push(t.src);

        const rataDataFormatted = moment(this.data, "DD-MM-yyyy").format("yyyy-MM-DD");
        
        return ( 

        <div key={Math.random()}  style={{display: this.props.show == true ? 'block' : 'none'}}> 
            <div style={container} onClick={() => { this.props.onClose(false); this.setState({ visible: false }); }}>
            <div style={mainClass} onClick={(e) => e.stopPropagation()}>
                
            <div style={closeBtn} onClick={() => {
                this.setState({visible: false});
                this.props.onClose(false);
            }}>
                <img alt="" src={ require('../images/close_icon.png')} style={{ width: 30, height: 30, cursor: 'pointer' }} />
            </div>

                {this.props.rata.studente && <div style={windowTitle}>{ this.props.rata.studente.nome.replace(/\\/g, '') + ' ' + this.props.rata.studente.cognome.replace(/\\/g, '') }</div> }
                <div style={windowSubtitle}>{this.props.rata.corso.name}</div>
                <MyDatePicker name={tr('data')} ref={this.rataDateRef} value={rataDataFormatted} onChange={data => {
                    this.data = data;
                    }
                }/>
                <TextInput ref={this.importoRef} name={tr('importo')} value={this.importo} onChange={(text) => { this.importo = text}} />


                { this.props.isStudent == true && 
                (
                    <>
                <SelectInput key={Math.random()} 
                    value={this.state.option} 
                    name={tr('stato') + ":"} 
                    options={this.options} 
                    isMulti={false}
                    onChange={(option) => {
                        this.setState({
                            option: option
                        });
                    }}
                />


                <TextInput key={Math.random()} name={tr('note')} value={this.newNote ? this.newNote : this.state.note} 
                    onChange={(text) => { this.newNote = text}
                } />

                <div style={{width: '100%', display: 'inline-flex', overflowY: 'scroll', overflowX: 'hidden' }}>
                {
                    this.files.map(file => {
                        return <div><a target="_blank" href={file}><img alt="" src={fileImage} /></a>
                            <div style={{position: 'relative', top: '-90px', left: '30px', cursor: 'pointer'}} onClick={
                                () => {
                                    if (window.confirm(tr('elimina_immagine')) == false) return;
                                    this.deletedFiles.push(file);
                                    this.setState({ });
                                }
                            }>X</div>
                        </div>;
                    })
                }
                </div>
                <ImageSilentInput name={tr('aggiungi_documento')} key={Math.random()} 
                    value={this.state.imageToLoad}
                    onChange={async (base64) => {
                    const photoId = uuid()
                    const cookies = new Cookies();
                    const token = cookies.get('token', { path: '/' });
                    const username = cookies.get('username', { path: '/' });

                    let retPhotoObj = await saveFile(username, token, photoId, base64);
                    const fileName = 'http://' + Constants.mainUrl + retPhotoObj.name;
                    this.newFiles.push({
                        id: photoId,
                        src: fileName,
                        width: 1,
                        height: retPhotoObj.height / retPhotoObj.width
                    });

                    this.setState({ });
                    }} 
                />
                </>
                )}
          
                <Button callback={async () => {

                        var filesString = '';
                        for (var str of this.files){
                            if (filesString != '') filesString = filesString + ';';
                            filesString = filesString + str;
                        }

                        var note = this.newNote != undefined ? this.newNote : this.state.note;
                        var rataDate = this.rataDateRef.current.getDate();
                        rataDate = (moment (rataDate).format("DD-MM-yyyy"));

                        const cookies = new Cookies();
                        const username = cookies.get('username', { path: '/' });
                        const token = cookies.get('token', { path: '/' });
                        var rata = this.props.rata;
                        
                        rata.id_corso = rata.corso.id;
                        rata.id_studente = rata.studente.id;
                        rata.importo = this.importo;
                        rata.data = rataDate;
                        rata.note = note;
                        rata.files = filesString;
                        rata.status = this.state.option.value;

                        await addRataStatus(username, token, rata.corso.id, rata.studente.id, rataDate, this.importo, this.state.option.value, filesString, note);
                        this.props.onClose(true);

                }} title={tr('salva').toUpperCase()}></Button>
            </div>
            </div>
        </div>
        )
    }


}


const windowTitle = {
    color: 'darkgrey', 
    fontSize: 30, 
    fontWeight: 'bold', 
    fontFamily: 'Teko', 
    textAlign:'left', 
    marginLeft: 5, 
}

const windowSubtitle = {
    color: 'darkgrey', 
    fontSize: 20, 
    fontFamily: 'Teko', 
    textAlign:'left', 
    marginLeft: 5, 
    marginBottom: 10,
    marginTop: -5,
}

const mainClass = {
    
    position: 'absolute',
    top: '100px',
    left: 'calc((100% - 400px)/2)', 
    height: '560px',
    background: 'white',
    padding: '2%', 
    width: '400px',
    minWidth: '350px',
    boxShadow: '0px 2px 10px darkgrey',
    borderRadius: '10px', 
    overflowX: 'hidden', 
    overflowY: 'scroll',
}

const container = {
    position: 'fixed', 
    display: 'block', 
    top: 0,
    left: 0, 
    bottom: 0, 
    right: 0,
    minWidth: '100%', 
    minHeight: '100%', 
    backgroundColor: '#3C3C3C4D',
    overflowX: 'hidden', 
    overflowY: 'scroll',
}

const closeBtn = {
    position: 'absolute',
    right: 10,
    top: 10,
    padding: 10,
    cursor: 'pointer', 
    zIndex: 999, 
}